import React, { useState, useEffect }  from 'react';


import './myProfile.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import { RiDeleteBinLine } from "react-icons/ri";

import axios from "axios";
import config from '../../config/config'
import Swal from 'sweetalert2'



import { IoEyeOutline } from "react-icons/io5";
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';




import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import AccountSidebar from '../../components/sidebar/accountSidebar';

import {connect} from 'react-redux';
import * as actions from '../../store/customer/actions';




const MyProfile =({getCustomerProfile, updateProfile, customerProfile, changePassword}) => {  

    const [ formData, setFormData ] = useState()
    const [ formDataEnter, setFormDataEnter] = useState(false);
    const [ formSubmitted, setFormSubmitted ] = useState(false);
    const [ erros, setErrors ] = useState({});
    const [ validated, setvalidated ] = useState(false);

    const [ passwordFormData, setPasswordFormData ] = useState({
        current_password: '',
        password: '',
        confirm_password: ''
    })
    const [ passwordFormSubmitted, setPasswordFormSubmitted ] = useState(false);
    const [ passwordErros, setPasswordErrors ] = useState({});

    useEffect(() => {
		loadData();
	},[]);

    useEffect(() => {
        if(customerProfile && formDataEnter === false){
            // console.log(customerProfile)
            setFormData({
                email: customerProfile.email,
                full_name: customerProfile.full_name,
                mobile_number: customerProfile.mobile_number
            })
            setFormDataEnter(true);
        }
	},[customerProfile]);

    const loadData = async() => {
        await getCustomerProfile({token: localStorage.getItem('user')}).then(res => {
            // console.log()
        })
    }

    
    const handleImageChange = (event) => {
        const file = event.target.files[0];
        uploadProfilePic(file);
    };

    const uploadProfilePic = async(file) => {
        const formData = new FormData();
        formData.append("images[]", file); // Append file
        
        try {
            const response = await axios.post(config.blogApiUrl+'customer/upload-profile-pic.json?token='+localStorage.getItem('user'), formData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            
            getCustomerProfile({token: localStorage.getItem('user')})

        } catch (error) {
            console.error("Upload error:", error);
        }
    }

    const handleChange = (e) => { 
        const { name, value } = e.target;
        
        setFormData({
            ...formData,
            [name]: value
        });  

        if(formSubmitted){
            findFormErrors();
        }
    }

    const findFormErrors = () => {
        const { full_name, email, mobile_number } = formData
        let newErrors = {}

        
        // password errors
        if ( !full_name || full_name === '' ) newErrors.full_name = 'Name cannot be blank!'
        if ( !mobile_number || mobile_number === '' ) newErrors.mobile_number = 'Phone number cannot be blank!'
        if ( !email || email === '' ) newErrors.email = 'Enter email address'
        if(email && !validateEmail(email)){
            newErrors.email = 'Your e-mail has been entered in the wrong format. Please check and try again';
          }
        // console.log('newErrors', newErrors)
        setErrors(newErrors);
        return newErrors
    }

    const validateEmail = (email) => {
        return email.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
    }

    const handleSubmit = (event) => { 
        
        setFormSubmitted(true);
        const checkErrors = findFormErrors();
        // console.log('check 1',checkErrors);
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        
        if ( Object.keys(checkErrors).length > 0 ) {
            // We got errors!
            setErrors(checkErrors);
            // console.log('check 3');
        } else {
            
            updateProfile(formData).then(res => {
                if(res.payload.response && res.payload.response.status == 422){
                    console.log(res.payload.response.data.message.message)
                    Swal.fire({
                        title: "Error!",
                        text: res.payload.response.data.message.errors,
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    });
                } else if(res.payload && res.payload.data){
                    Swal.fire({
                        title: "Success",
                        text: 'Profile updated successfully',
                        icon: 'success',
                        confirmButtonText: 'Ok'
                    });
                }
            });
            
        }
    }

    const handlePasswordChange = (e) => { 
        const { name, value } = e.target;
        
        setPasswordFormData({
            ...passwordFormData,
            [name]: value
        });  

        if(formSubmitted){
            findPasswordFormErrors();
        }
    }

    const findPasswordFormErrors = () => {
        const { current_password, password, confirm_password } = passwordFormData
        let newErrors = {}

        
        // password errors
        if ( !current_password || current_password === '' ) newErrors.current_password = 'Current password cannot be blank!'
        if ( !password || password === '' ) newErrors.password = 'Password cannot be blank!'
        if ( !confirm_password || confirm_password === '' ) newErrors.confirm_password = 'Confirm password cannot be blank!'
        if(password !=  confirm_password){
            newErrors.confirm_password = 'Password mismatch!'
        }
        setPasswordErrors(newErrors);
        return newErrors
    }

    
    const handlePasswordSubmit = (event) => { 
        console.log('called')
        setPasswordFormSubmitted(true);
        const checkErrors = findPasswordFormErrors();
        // console.log('check 1',checkErrors);
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        
        if ( Object.keys(checkErrors).length > 0 ) {
            // We got errors!
            setErrors(checkErrors);
            // console.log('check 3');
        } else {
            
            changePassword(passwordFormData).then(res => {
                
                if(res.payload.response && res.payload.response.status == 422){
                    console.log(res.payload.response.data.message.message)
                    Swal.fire({
                        title: "Error!",
                        text: res.payload.response.data.message.errors,
                        icon: 'error',
                        confirmButtonText: 'Ok'
                    });
                } else if(res.payload && res.payload.data && res.payload.data.message){
                    Swal.fire({
                        title: "Success",
                        text: res.payload.data.message,
                        icon: 'success',
                        confirmButtonText: 'Ok'
                    });
                }
            });
            
        }
    }

    // console.log('customerProfile', customerProfile)
    return (
        <div>
            <Header/>            
            <section className='pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center'>
                        <AccountSidebar />
                        <Col lg={9}>
                            <div class="card shadow p-4">
                                <h5>Account Information</h5>

                                <Form className='mb-5' validated={validated} onSubmit={handleSubmit}>
                                    <Row className="mb-3">
                                    <Form.Group as={Col} controlId="formGridEmail">
                                            <Form.Label>Upload Photo</Form.Label>
                                                <Form.Control
                                                    type="file"
                                                    onChange={handleImageChange}
                                                />
                                            </Form.Group>
                                    </Row>
                                    <Row>
                                        <Form.Group as={Col} controlId="formGridEmail">
                                            <Form.Label>Full Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="full_name" 
                                                    defaultValue={formData && formData.full_name ? formData.full_name : ''} 
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        <Form.Group as={Col} controlId="formGridPassword">
                                            <Form.Label>Phone Number</Form.Label>
                                            <InputGroup className="mb-3">
                                                <InputGroup.Text id="basic-addon1">+91</InputGroup.Text>
                                                <Form.Control
                                                placeholder="999999999"
                                                name="mobile_number" 
                                                defaultValue={formData && formData.mobile_number ? formData.mobile_number : ''} 
                                                onChange={handleChange}
                                                />
                                            </InputGroup>
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId="formGridEmail">
                                            <Form.Label>Email</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="email" 
                                                    defaultValue={formData && formData.email ? formData.email : ''} 
                                                    onChange={handleChange}
                                                />
                                        </Form.Group>
                                        {/* <Form.Group as={Col} controlId="formGridEmail">
                                            <Form.Label>Your Title</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    id="inputPassword5"
                                                    aria-describedby="passwordHelpBlock"
                                                />
                                        </Form.Group> */}
                                    </Row>
                                    <Row className="mb-3">
                                        <div>
                                            <Button variant="info" size="lg" type="submit">Save Changes</Button>
                                        </div>
                                    </Row>
                                </Form>
                                <h5>Change Password</h5>
                                <Form className='mb-5'  onSubmit={handlePasswordSubmit}>
                                    <Row className="mb-3">
                                    <Form.Group as={Col} controlId="formGridPassword">
                                            <Form.Label>Current Password</Form.Label>
                                            <InputGroup className="mb-3">
                                            <Form.Control
                                            placeholder="Password"
                                            type="password" 
                                            name="current_password" 
                                            onChange={handlePasswordChange}
                                            />
                                            <Button variant="outline-secondary" id="button-addon2">
                                                <IoEyeOutline />
                                            </Button>
                                        </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridPassword">
                                            <Form.Label>New Password</Form.Label>
                                            <InputGroup className="mb-3">
                                            <Form.Control
                                            placeholder="Password"
                                            name="password"
                                            type="password" 
                                            onChange={handlePasswordChange}
                                            />
                                            <Button variant="outline-secondary" id="button-addon2">
                                                <IoEyeOutline />
                                            </Button>
                                        </InputGroup>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridPassword">
                                            <Form.Label>Confirm Password</Form.Label>
                                            <InputGroup className="mb-3">
                                            <Form.Control
                                            placeholder="Password"
                                            name="confirm_password"
                                            type="password" 
                                            onChange={handlePasswordChange}
                                            />
                                            <Button type="submit" variant="outline-secondary" id="button-addon2">
                                                <IoEyeOutline />
                                            </Button>
                                        </InputGroup>
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-3">
                                        <div>
                                            <Button type="submit" variant="info" size="lg">Save Changes</Button>
                                        </div>
                                    </Row>

                                    </Form>
                                <div className="d-none">
                                <h5>Delete Account</h5>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed accumsan felis nunc, ut sagittis augue imperdiet quis. Vestibulum bibendum ultricies ipsum, id suscipit ligula facilisis ac. Praesent ultricies augue metus</p>
                                <Button variant="danger" size="md"><RiDeleteBinLine /> Delete</Button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            
            <Footer/>
        </div>
    )
}
function mapStateToProps(state) {
    return {
        customerProfile: state.customer.customerProfile
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        updateProfile: (post) => dispatch(actions.updateProfile(post)),
        getCustomerProfile: (post) => dispatch(actions.getCustomerProfile(post)),
        changePassword: (post) => dispatch(actions.changePassword(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(MyProfile);